import { useState, useEffect } from 'react';
import Proptypes from 'prop-types';

import API from 'services/API';
import JWTService from 'services/JWT';
import AuthContext from './context';
import { Loader } from '../../components/generics/Loader/Loader';

const Auth = ({ children }) => {
  const [loading, isLoading] = useState(true);
  const [user, setUser] = useState(null);

  useEffect(() => {
    if (user) {
      isLoading(false);
    }
  }, [user]);

  const JWTCheck = () =>
    new Promise(resolve => {
      JWTService.on('onAutoLogout', () => {
        setUser(null);
        isLoading(false);
        resolve();
      });

      JWTService.on('onNoAccessToken', () => {
        isLoading(false);
        resolve();
      });

      JWTService.on('onLogged', data => {
        if (data) {
          setUser(data);
        }
      });

      JWTService.init();

      return resolve();
    });

  /**
   * Component Did Mount for call JWT Check
   */
  useEffect(() => {
    JWTCheck()
      .then(() => {})
      .catch(() => console.error('redirect login'));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const logout = () => {
    try {
      localStorage.removeItem('jwt_token');
      delete API.defaults.headers.common.Authorization;
      setUser(null);
    } catch (error) {
      console.error(error);
    }
  };

  return loading ? (
    <Loader />
  ) : (
    <AuthContext.Provider
      value={{
        user,
        setUser,
        logout,
      }}>
      {children}
    </AuthContext.Provider>
  );
};

Auth.propTypes = {
  children: Proptypes.element.isRequired,
};

export default Auth;
